import { LogLevel } from '../download-client/download-client';

export const BuildVersion = import.meta.env.BUILD_VERSION || '';
export const DefaultDatasetPageSize = parseInt(import.meta.env.VUE_APP_DEFAULT_DATASET_PAGESIZE || '10');
export const DefaultApiPort = parseInt(import.meta.env.VUE_APP_API_PORT || '7119');
export const DefaultBaseUri = import.meta.env.VUE_APP_BASE_URI || 'localhost';
export const DefaultBaseApiUri = import.meta.env.VUE_APP_BASE_API_URI;
export const DefaultApiVersionPath = import.meta.env.VUE_APP_API_VERSION_PATH || '';
export const IsProduction = import.meta.env.VUE_APP_ENV === 'production';
export const ApiLogLevel = (import.meta.env.VUE_APP_API_LOG_LEVEL as LogLevel) || LogLevel.Error;
export const DefaultLoginUrl = `${DefaultBaseUri}:${DefaultApiPort}${DefaultApiVersionPath}/auth/login`;
export const DefaultLogoutUrl = `${DefaultBaseUri}:${DefaultApiPort}${DefaultApiVersionPath}/auth/logout`;
export const SwitchIdentityUrl = `${DefaultBaseUri}:${DefaultApiPort}${DefaultApiVersionPath}/auth/switch-identity`;
export const Environment = (
  import.meta.env.VUE_APP_ENV ||
  import.meta.env.ASPNETCORE_ENVIRONMENT ||
  import.meta.env.NODE_ENV ||
  'production'
).toLowerCase();
export const DefaultHelpUrl =
  'https://www.vlaanderen.be/digitaal-vlaanderen/onze-oplossingen/downloadtoepassing/aan-de-slag#toegang-tot-de-downloadtoepassing';
export function GetDefaultLoginUrl() {
  return `${DefaultLoginUrl}?returnUrl=${window.location.href}`;
}
export const GtagId = import.meta.env.VUE_APP_GTAG;
export const ForcedPredefinedFilesProductIds: number[] = (
  import.meta.env.VUE_APP_FORCED_LIST_PREDEFINED_FILES_PRODUCT_IDS || ''
)
  .split(',')
  .map((id: string) => parseInt(id.trim(), 10))
  .filter((id: number) => !isNaN(id));
export const cookieLinkIdentifier =
  'https://www.vlaanderen.be/digitaal-vlaanderen/onze-oplossingen/downloadtoepassing/algemene-gebruiksvoorwaarden#cookies';
